import { Component, Optional, Input,EventEmitter,Output,ViewChild, ViewEncapsulation, ElementRef } from "@angular/core";
import { NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import { WebResService } from '../../webresolution/service/webresservices';
import { AuthService } from '../../core/auth-service.component';
import {MessageBox} from '../../commoncomponent/MessageBox/MessageBox';
import { InvoiceAttachmentsDTO } from "../../commonmodel/InvoiceAttachmentsDTO";
import { InvoiceDTO } from '../../commonmodel/InvoiceDTO';
import { HttpHeaders } from "@angular/common/http";
import { UntypedFormGroup, UntypedFormBuilder } from "@angular/forms";
import { EnvService } from "src/app/core/env.service";

@Component({
    selector: "atach-modal",
    styleUrls: ['./attach.css'],
    templateUrl: "./attach.component.html",
    encapsulation: ViewEncapsulation.None
})
export class AttachComponent {
  uploadSaveUrl:any; 
  uploadRemoveUrl = 'removeUrl'; 
  profileForm: UntypedFormGroup;
  message: string;
  style: string;
  public progress: number;
  public invdata:Array<InvoiceDTO> = [];
  @Input() invs:Array<InvoiceDTO> = [];
  @Input() commaSeparatedInvId: any;
  public fFile = [];
  public fileAttachment:Array<InvoiceAttachmentsDTO>= [];
  public invIds:any;
  @Output() eventEmitter: EventEmitter<any> = new EventEmitter();
  public fileCount = 0;
  @Input() public myFiles:string [] = [];
  @ViewChild('attachments',{static: false}) attachment: any;
  @ViewChild('pBar', {static: false}) pBar: ElementRef;
  @ViewChild('msg', {static: false}) msg: ElementRef;
  @ViewChild('mdi', {static: false}) mdi: ElementRef;
  @ViewChild('clrFile', {static: false}) clrFile: ElementRef;
  @ViewChild('progressCount', {static: false}) progressCount: ElementRef;
  constructor(private fb: UntypedFormBuilder, private _authService: AuthService,public _env: EnvService, private _webResService: WebResService,
    @Optional() private readonly activeModal: NgbActiveModal,private _messageBox:MessageBox) { }
  ngOnInit() {
    console.log(this.invs)
    this.profileForm = this.fb.group({
      name: [''],
      profile: ['']
    });
    this._webResService.getFileAttachment(this.commaSeparatedInvId).subscribe((data) => {
      this.fileAttachment = data;
    })
    this._authService.getAccessToken().then(token =>{
      this.uploadSaveUrl = this._env.apiWebResolution +'WebResInvoice/UploadWebResFile?invoiceIds='+this.commaSeparatedInvId,{headers: new HttpHeaders({'ngsw-bypass': 'true'}).set('Authorization', `Bearer ${token}`)}
    })
  }
  public onSelectEvent(e) {
    this.fileCount += 1;
  }
  public getFileDetails (e) {
      var files = "";
      let scope = this
      for (var i = 0; i < e.target.files.length; i++) { 
          //to do: split all specaill character to get actual filename of the image
          var sFile = e.target.files[i].name;
          var d = sFile.split("_");
          var z = d.join("");
          scope.fFile = scope.fileAttachment.map(function(o) {return o.RawFileName});
          let y = scope.fFile.indexOf(z);
          if(y === -1)
          {
            this.myFiles.push(e.target.files[i]);
            files = files + e.target.files[i] 
          }
          else
          {
            this._messageBox.open("File already exists");
            this.clrFile.nativeElement.value = null;
          }
        }

        this.invs.forEach(function (invoice) {  
            for (var i = 0; i < e.target.files.length; i++) { 
              var attachment = <InvoiceAttachmentsDTO>{};
              attachment.InvoiceId = invoice.Id;
              attachment.RawFileName = e.target.files[i].name;
              this.fileAttachment.push(attachment);
            }
          });  
          this.attachment.nativeElement.value = '';
    }
  public removeSelectedFile(invoiceAttachment) {
    this._webResService.removeFile(invoiceAttachment.InvoiceId,invoiceAttachment.RawFileName).subscribe((data) => { });
      this.fileAttachment  =  this.fileAttachment.filter(function(inv){
      return inv.RawFileName != invoiceAttachment.RawFileName
    });
  }

  public uploadFile(){
    console.log('uploading');
    if(this.clrFile.nativeElement.value === null || this.clrFile.nativeElement.value === "")
    {
      this._messageBox.open("Please attach file first")
    }
    else{
      var formData = new FormData();
      for(let i =0; i < this.myFiles.length; i++){
      formData.append("files", this.myFiles[i], this.myFiles[i]['name']);
      }
      this.pBar.nativeElement.innerHTML = '0%';
      this.progress = 0;
      const ids = this.invs.map(inv => inv.Id);
      var commaSeparatedIDs = ids.join();
      this._authService.getAccessToken().then(token =>{
      this._webResService.uploadFile(commaSeparatedIDs,formData,token).subscribe(event => {
          return event;
        }, error => {
        console.log(error);
        });
      })
    }
  }
  
  public dismiss(): void {
      if (this.activeModal)
        this.activeModal.dismiss();
  }
}